import "./Cart.css";
import Item from "../Item/Item";
import {
  FinancialData,
  ItemDetailsData,
  RecommendedItem,
} from "../../../../Utils/DefinitionsInterfaces";
import { NFOLogoNoText } from "../../../../Assets/svgs";
import Subtotal from "../Subtotal/Subtotal";
import MultipleItems from "../Item/MultipleItems";
import { motion } from "framer-motion";
import { formatExamDate } from "../../../../Utils/dateFormatter";

interface CartProps {
  stateDefaultItems: FinancialData[];
  stateCheckoutItems: ItemDetailsData[];
  stateRecommendedItems: RecommendedItem[];
  cbRemoveProduct: (itemId: number) => void;
  cbAddRecommended: (itemId: number) => void;
  cbHandlePaymentClick: () => void;
}

const Cart = (props: CartProps) => {
  return (
    <div className="cart-parent-wrapper">
      {/* {props.stateRecommendedItems.map((e, i) => {
        return (
          <motion.div
            key={`recommended-item-${i}`}
            onClick={() => {
              props.cbAddRecommended(e.id);
            }}
            initial={{ scale: 0.9 }}
            animate={{ scale: 1 }}
            transition={{ duration: 0.3 }}
            whileHover={{ scale: 1.01 }}
            style={{
              backgroundColor: "rgba(255, 255, 255, 1)",
              border: "solid 1px rgba(0,0,0,0.1)",
              width: "100%",
              padding: "20px 25px",
              borderRadius: "20px",
              marginBottom: "15px",
              cursor: "pointer",
            }}
          >
            <div
              style={{
                color: "rgba(36, 108, 193, 1)",
                alignSelf: "center",
                display: "flex",
                flexDirection: "row",
                alignItems: "center",
                fontSize: "18px",
                marginBottom: "10px",
                backgroundColor: "rgba(36, 108, 193, 0.1)",
                width: "fit-content",
                padding: "10px 10px",
                borderRadius: "10px",
              }}
            >
              Recommended Items
            </div>
            <div style={{ display: "flex", justifyContent: "space-between" }}>
              <div
                className="text-wrapper-3"
                style={{
                  maxWidth: "250px",
                  color: "rgba(36, 108, 193, 1)",
                  alignSelf: "center",
                  display: "flex",
                  flexDirection: "row",
                  alignItems: "center",
                  gap: "10px",
                }}
              >
                <img
                  src={e.image}
                  alt={e.name}
                  style={{ width: "50px", height: "50px" }}
                />
                <div style={{ display: "flex", flexDirection: "column" }}>
                  {e.name}
                  <span
                    style={{
                      marginTop: "5px",
                      backgroundColor: "rgba(2, 59, 143, 0.1)",
                      color: "rgba(2, 59, 143, 1)",
                      padding: "4px 8px",
                      borderRadius: "4px",
                      fontSize: "14px",
                      fontWeight: "500",
                      width: "fit-content",
                    }}
                  >
                    {Math.round(
                      ((e.base_price - e.selling_price) / e.base_price) * 100
                    )}
                    % OFF
                  </span>
                  {e.id === 3 && (
                    <div
                      style={{
                        color: "rgba(36, 108, 193, 0.8)",
                        fontSize: "14px",
                        fontWeight: "400",
                        fontFamily: "OggTextMedium",
                        marginTop: "5px",
                      }}
                    >
                      Exam Scheduled on : <br />
                      {e.examDate && `${formatExamDate(e.examDate)}`}
                    </div>
                  )}
                </div>
              </div>

              <div style={{ display: "flex", flexDirection: "column" }}>
                <div
                  style={{
                    display: "flex",
                    flexDirection: "row",
                    alignItems: "center",
                  }}
                >
                  <span
                    style={{
                      textDecoration: "line-through",
                      marginRight: "10px",
                      color: "rgba(138, 138, 138, 0.8)",
                    }}
                    className="text-wrapper-3"
                  >
                    {"₹" + e.base_price}
                  </span>
                  <span className="text-wrapper-3">
                    {"₹" + e.selling_price}
                  </span>
                </div>
                <div
                  style={{
                    backgroundColor: " rgba(138, 138, 138, 0.1)",
                    border: "0.56px solid rgba(138, 138, 138, 0.1)",
                    padding: "8px",
                    marginTop: "10px",
                    color: "rgba(2, 59, 143, 1)",
                    alignItems: "center",
                    justifyContent: "center",
                    display: "flex",
                    cursor: "pointer",
                    borderRadius: "10px",
                  }}
                >
                  + Add item
                </div>
              </div>
            </div>
          </motion.div>
        );
      })} */}

      <div className="cart">
        <div className="cart-child">
          <div className="cart-title">
            <div>
              <div className="text-wrapper-2">Purchase Details</div>
            </div>
            <img
              src={NFOLogoNoText}
              alt="NFO Logo"
              className="nfo-logo-details-section"
            />
          </div>

          {props.stateCheckoutItems.length > 1 ? (
            <MultipleItems
              stateCheckoutItems={props.stateCheckoutItems}
              cbRemoveProduct={props.cbRemoveProduct}
              key={`multiple-items-${props.stateCheckoutItems.length}`}
              isDefaultItem={true}
            />
          ) : (
            props.stateCheckoutItems.map((e, i) => (
              <Item
                stateCheckoutItem={e}
                cbRemoveProduct={props.cbRemoveProduct}
                key={`item-${i}`}
                isDefaultItem={true}
              />
            ))
          )}
        </div>
        <div className="button-container">
          <Subtotal
            stateCheckoutItems={props.stateCheckoutItems}
            cbHandlePaymentClick={props.cbHandlePaymentClick}
          />
        </div>
      </div>
    </div>
  );
};

export default Cart;
